import React from "react";
import { useMutation } from "@tanstack/react-query";
import { submitPut } from "../../../../../../enums/queryFunction/Submit";
import { SnackbarContext } from "../../../../../../contexts/Snackbar";
import { snackbarSeverity } from "../../../../../../hooks/useSnackbar";
import { INVOICE_SETTINGS } from "../../../../../../enums/ApiPaths";

export default function useInvoiceSettingsMutations(clinicId) {
  const { handleSnackbar } = React.useContext(SnackbarContext);

  async function runMutation(mutation, payload) {
    try {
      const response = await mutation.mutateAsync(payload);
      handleSnackbar("success", snackbarSeverity.SUCCESS);
      return response?.data ?? null;
    } catch (error) {
      handleSnackbar(error, snackbarSeverity.ERROR);
      return null;
    }
  }

  const updateMutation = useMutation({
    mutationFn: (data) => submitPut(`${INVOICE_SETTINGS}${clinicId}`, data),
  });

  const sequenceMutation = useMutation({
    mutationFn: (nextInvoiceNumber) =>
      submitPut(`${INVOICE_SETTINGS}${clinicId}/sequence`, { nextInvoiceNumber }),
  });

  return {
    updateSettings: (scheme, premisesCode) => runMutation(updateMutation, { scheme, premisesCode }),
    isUpdating: updateMutation.isPending,
    setStartingSequence: (nextInvoiceNumber) => runMutation(sequenceMutation, nextInvoiceNumber),
    isUpdatingSequence: sequenceMutation.isPending,
  };
}
